import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
} from '@angular/core';

import { ScreenReaderLiveService } from './screen-reader-live.service';

@Component({
    selector: 'cmps-wait-status',
    template: ` <div
        class="cmps-wait-status-loader"
        aria-hidden="true"
    >
        <div
            class="background"
            [ngClass]="{
                center: center,
                fixed: fixed,
                absolute: absolute,
                modal: modal
            }"
            *ngIf="background"
        ></div>
        <div
            [ngClass]="{
                center: center,
                fixed: fixed,
                absolute: absolute,
                modal: modal
            }"
        >
            <div>
                <cmps-icon svgIcon="progress-helper"></cmps-icon>
                <span class="d-block">{{ status }}</span>
            </div>
        </div>
    </div>`,
    host: {
        '[attr.aria-label]': 'srStatus || status',
    },
})
export class WaitStatusComponent implements OnChanges, OnInit, OnDestroy {
    @Input() background: boolean;
    @Input() center: boolean;
    @Input() fixed: boolean;
    @Input() absolute: boolean;
    @Input() modal: boolean;
    @Input() status: string;
    @Input() srStatus: string;
    @Input() srInitialAnnounce: boolean;

    constructor(
        private readonly _screenReaderLiveService: ScreenReaderLiveService,
    ) {
        this.background = true;
        this.center = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.srInitialAnnounce) return;
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('status') && !this.srStatus) {
            this._screenReaderLiveService.announce(this.status);
        }
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('srStatus')) {
            this._screenReaderLiveService.announce(this.srStatus);
        }
    }

    ngOnInit(): void {
        if (this.fixed) {
            document.body.classList.add('cmps-wait-status-loader-fixed');
        }
    }

    ngOnDestroy(): void {
        if (this.fixed) {
            document.body.classList.remove('cmps-wait-status-loader-fixed');
        }
    }
}
